import { render } from "./openAdvise.vue?vue&type=template&id=6acd51a3&scoped=true&ts=true"
import script from "./openAdvise.vue?vue&type=script&lang=ts"
export * from "./openAdvise.vue?vue&type=script&lang=ts"

import "./openAdvise.vue?vue&type=style&index=0&id=6acd51a3&lang=scss&scoped=true"

import exportComponent from "E:\\project\\help-center\\help-center-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6acd51a3"]])

export default __exports__